/**
 * check if given url is a DOI URL
 * @param url given url to check
 * @returns boolean
 */
export const isDoiUrl = (url: string): boolean => {
  if (!url) return false
  const regEx = RegExp(/^.*(10.\d{4,9}\/[-._;()/:A-Za-z0-9]+).*$/)
  return !!url.match(regEx)
}
